<template>
  <v-card>
    <v-card-title>
      Teachers
      <v-spacer></v-spacer>
      <ReturnHomeBtn />
    </v-card-title>
    <v-card-text>
      <v-container>
        <v-row>
          <v-spacer></v-spacer>
          <v-col cols="12" sm="8" md="5">
            <v-radio-group v-model="filterOption" row>
              <v-radio label="All" value="all"></v-radio>
              <v-radio label="Active only" value="active"></v-radio>
              <v-radio label="Evaluators only" value="evaluator"></v-radio>
            </v-radio-group>
          </v-col>
          <v-col cols="12" sm="4" md="7">
            <v-text-field
              v-model="search"
              append-outer-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
    <v-data-table
      :loading="!teachers"
      loading-text="Loading... Please wait"
      :headers="headers"
      :items="teachersFiltered"
      :search="search"
    >
      <template v-slot:top>
        <v-toolbar-title v-if="dialog">
          <v-dialog v-model="dialog" class="mx-auto" max-width="500">
            <v-form ref="form">
              <v-card>
                <v-card-title>Teacher {{editedItem.firstName}} {{editedItem.lastName}}</v-card-title>
                <v-card-text>
                  <v-checkbox v-model="editedItem.isActive" label="Is Active?"></v-checkbox>
                </v-card-text>
                <v-card-text>
                  <v-checkbox v-model="editedItem.isEvaluator" label="Is Evaluator?"></v-checkbox>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn text @click="close">Cancel</v-btn>
                  <v-btn color="primary" @click="save">Save</v-btn>
                </v-card-actions>
              </v-card>
            </v-form>
          </v-dialog>
        </v-toolbar-title>
      </template>
      <template v-slot:item.id="{ item }">
        <v-chip label outlined :color="item.color" class="font-weight-bold">{{ item.id }}</v-chip>
      </template>

      <template v-slot:item.isActive="{ item }">
        <v-simple-checkbox v-model="item.isActive" disabled></v-simple-checkbox>
      </template>
      <template v-slot:item.isEvaluator="{ item }">
        <v-simple-checkbox v-model="item.isEvaluator" disabled></v-simple-checkbox>
      </template>

      <template v-slot:item.actions="{ item }">
        <v-layout :justify-end="true">
          <v-icon class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
        </v-layout>
      </template>
    </v-data-table>
  </v-card>
</template>
<script>
import { mapActions, mapState } from "vuex";
import ReturnHomeBtn from "../components/ReturnHomeBtn.vue";

export default {
  name: "Teachers",
  components: { ReturnHomeBtn },
  computed: {
    ...mapState(["teachers"]),
    teachersFiltered: function() {
      if (this.filterOption === "active") {
        return this.teachers.filter(x => x.isActive);
      }
      if (this.filterOption === "evaluator") {
        return this.teachers.filter(x => x.isEvaluator);
      }
      return this.teachers;
    }
  },
  data() {
    return {
      search: "",
      headers: [
        {
          text: "Id",
          value: "id",
          align: "start"
        },
        {
          text: "First Name",
          value: "firstName"
        },
        {
          text: "Last Name",
          value: "lastName"
        },
        {
          text: "Is Active",
          value: "isActive"
        },
        {
          text: "Is Evaluator",
          value: "isEvaluator"
        },
        {
          text: "Actions",
          value: "actions",
          sortable: false,
          align: "end"
        }
      ],
      filterOption: "all",
      dialog: false,
      editedItem: {}
    };
  },
  methods: {
    ...mapActions(["updateTeacherIsActiveAction"]),

    async save() {
      try {
        const model = {
          adminId: this.$store.state.user.id,
          teacherId: this.editedItem.id,
          isActive: this.editedItem.isActive,
          isEvaluator: this.editedItem.isEvaluator
        };
        console.log("themodel", model);
        await this.updateTeacherIsActiveAction({
          model: model,
          token: this.$store.state.token
        });
        this.close();
      } catch (err) {
        this.$store.state.error = this.errorMessage(err);
        this.$store.state.snackbar = true;
        console.log(err);
      }
    },
    editItem(item) {
      this.editedItem = Object.assign({}, item);
      console.log("this.editedItem", this.editedItem);
      this.dialog = true;
    },
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = {};
      }, 300);
    }
  }
};
</script>